import { FEATURES } from '@/src/constants/Text'

// Fonte única de título/subtítulo por rota da tesouraria. Consumido pelo
// NavBarNavigation (route-header) e pelo ConditionalTeleport das views (fallback
// inline quando a Navegação 2026 está desligada).
export const TREASURY_ROUTE_HEADERS = {
  'treasury.contas_a_pagar': {
    title: 'Contas a pagar',
    subtitle: 'Gerencie e acompanhe as contas a pagar do escritório.',
  },
  'treasury.contas_a_receber': {
    title: 'Faturamento',
    subtitle:
      'Acompanhe todo o histórico dos seus pedidos de emissão de nota fiscal.',
  },
  'treasury.solicitations': {
    title: 'Solicitações',
    subtitle: 'Acompanhe e gerencie as solicitações do escritório.',
  },
}

// Lista [{ name, title, subtitle }] para o :routes do ConditionalTeleport.
export const treasuryRoutes = () =>
  Object.keys(TREASURY_ROUTE_HEADERS).map((name) => ({
    name,
    title: TREASURY_ROUTE_HEADERS[name].title,
    subtitle: TREASURY_ROUTE_HEADERS[name].subtitle,
  }))

export const treasuryOptionsRoutes = (currentUser, show) => {
  let router = [
    show[FEATURES.TREASURY] && {
      name: 'treasury.contas_a_pagar',
      title: 'Contas a pagar',
      subtitle: TREASURY_ROUTE_HEADERS['treasury.contas_a_pagar'].subtitle,
      meta: { can_show: FEATURES.TREASURY },
    },
  ]

  if (currentUser.IS_GESTOR || currentUser.IS_FINANCIAL) {
    router = [
      ...router,
      show[FEATURES.FATURAMENTO] && {
        name: 'treasury.contas_a_receber',
        title: 'Faturamento',
        subtitle: TREASURY_ROUTE_HEADERS['treasury.contas_a_receber'].subtitle,
        meta: {
          can_show: FEATURES.FATURAMENTO,
          only_manager: true,
          permission: ['gestor', 'financeiro'],
        },
      },
    ] // {name, title}
  }

  router = [
    ...router,
    show[FEATURES.TESOURARIA_FORMULARIO_REEMBOLSO] && {
      name: 'treasury.solicitations',
      title: 'Solicitações',
      subtitle: TREASURY_ROUTE_HEADERS['treasury.solicitations'].subtitle,
      meta: {
        can_show: FEATURES.TESOURARIA_FORMULARIO_REEMBOLSO,
      },
    },
  ]

  return router.filter((item) => item)
}

// Paginação client-side da tabela de Contas a pagar. Escritórios grandes têm
// 300-400+ lançamentos/mês; renderizar tudo de uma vez (items-per-page = -1)
// travava a tela. -1 = "Todos" (v-data-table).
export const BILLS_PER_PAGE_OPTIONS = [10, 25, 50, 100, -1]
export const BILLS_PER_PAGE_DEFAULT = 25
